import React, { useState, useEffect } from 'react';
import { PrivacyFooter } from '../Shared/PrivacyFooter';
import { getLogo } from '../Shared/Functions';
import { Grid } from '@mui/material';
import { PageTitle } from '../Dashboard/PageTitle';
import GlobalAlerts from '../Shared/GlobalAlerts';

export const PaymentBox = ({ children }) => {
    let [logo, setLogo] = useState<string>("")

    useEffect(() => {
        getLogo().then((x:any) => setLogo(x))
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <a href="#payment-main-content" className="sr-only sr-only-focusable">Skip to main content</a>
            <Grid container id="dashboard" style={{ width:"100%", height: "auto" }} className={'main-content'}>
                <GlobalAlerts />
                <Grid xs={12} id="header-bar" style={{ backgroundColor: "white", height: "100px", paddingTop: "10px"}}>
                    <div style={{display: "flex", justifyContent: "space-around"}}>
                        <img className="navbar-logo" src={logo} style={{height:"90px"}} alt="" />
                    </div>
                </Grid>
                <Grid xs={12}>
                    <PageTitle />
                </Grid>
                <Grid className='content-container'>
                    <Grid item sm={12} className={'main-content'}>
                        <Grid id="payment-main-content" style={{ display: "block", marginLeft: "auto", marginRight: "auto", maxWidth:"1500px" }}>
                            {children}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={12} id="privacy-footer" style={{ marginBottom: "10px", marginLeft: "auto", marginRight: "auto" }}>
                    <PrivacyFooter />
                </Grid>
            </Grid>
        </>)
}
